import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/account/")({
	component: AccountIndexPage,
	ssr: false,
});

function AccountIndexPage() {
	return <Navigate replace to="/account/settings" />;
}
